import { ComposeViewState, composeStore } from 'owa-mail-compose-store';
import getRecipientWellValues from './getRecipientWellValues';
import ReadWriteRecipientWellViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientWellViewState';
import { RecipientsCollection } from 'owa-attachment-well-data/lib/utils/includeMostRecentAttachmentsInfoBarMessage';

export default function findComposeFromRecipientWell(
    recipientWell: ReadWriteRecipientWellViewState
): ComposeViewState {
    let currentViewState: ComposeViewState = null;
    let recipients: RecipientsCollection = null;
    if (recipientWell && recipientWell.recipients) {
        for (const viewState of [...composeStore.viewStates.values()]) {
            recipients = getRecipientWellValues(viewState);
            if (
                recipients.toRecipients === recipientWell.recipients ||
                recipients.ccRecipients === recipientWell.recipients ||
                recipients.bccRecipients === recipientWell.recipients
            ) {
                currentViewState = viewState;
                break;
            }
        }
    }
    return currentViewState;
}
